import React from 'react';
import { useTheme } from '@mui/material';

import { CustomIcon } from 'modules/components/layer00';
import { SaveMilestoneForm } from 'modules/components/layer12';
import { BasicFormModalLayout } from 'modules/components/layer13';


export type SaveMilestoneModalProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: SaveMilestoneModalProps) => {
  const theme = useTheme();
  return (
    <BasicFormModalLayout.FC
      title='Save Milestone'
      subTitle='Enter milestone information below'
      handleClose={props.handleClose}
      isVisible={props.isVisible}
      headerIcon={(
        <CustomIcon.large.FC
          icon='PLUS'
          stroke={theme.palette.primary.main}
        />
      )}

      id={props.id}
    >
      <SaveMilestoneForm.FC
        id={props.id}
        handleClose={() => props.handleClose()}
      />
    </BasicFormModalLayout.FC>
  );
};
